import React from 'react';
import { isNull, isUndefined } from 'lodash';
import { Container } from 'react-bootstrap';

import { Loading, BackButton, LoadingError } from '@components/Base';
import SupportSection from '@components/SupportSection';
import { routeHealthQuoteBuyNewPage } from '@components/HealthQuoteBuyRoute';
import { routeHealthQuotePage } from '@components/HealthQuotePage';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote';

import { useHealthQuoteFind } from '../hook';
import { routeHealthQuoteSendEmailPage } from '../route';
import { HeaderSection } from './header-section';
import { FeatureSection } from './feature-section';
import { BenefitSection } from './benefit-section';
import { HospitalSection } from './hospital-section';
import { MemberSection } from './member-section';
import { ExclusionSection } from './exclusion-section';
import { DocumentSection } from './document-section';

const HealthQuoteDetailsPage = () => {
  const params = useQuoteOptionParams();
  const healthQuote = useHealthQuoteFind();

  if (isUndefined(healthQuote)) return <Loading />;
  if (isNull(healthQuote)) return <LoadingError />;

  const { healthPlanId, healthPlanName } = healthQuote;

  return (
    <>
      <Container className="mt-4">
        <BackButton className="mb-4" />
      </Container>

      <HeaderSection
        {...healthQuote}
        planName={healthPlanName}
        buyLinkTo={routeHealthQuoteBuyNewPage({ ...params, healthPlanId })}
        sendEmailLinkTo={routeHealthQuoteSendEmailPage({ ...params, healthPlanId })}
      />
      <FeatureSection {...healthQuote} />
      <BenefitSection {...healthQuote} />
      <ExclusionSection {...healthQuote} />
      <DocumentSection {...healthQuote} />
      <HospitalSection {...healthQuote} />
      <MemberSection {...healthQuote} formLinkTo={routeHealthQuotePage({ path: 'members', ...params })} />

      <SupportSection />
    </>
  );
};

export { HealthQuoteDetailsPage };
